export default __webpack_public_path__ + "static/media/create-rule.22235f2c.png";